/** Remove retired tracking storage without loading the former analytics SDK. */
export function removeLegacyAnalytics(): void {
  try {
    for (const key of Object.keys(localStorage)) {
      if (
        /^ph_.*_posthog$/.test(key) ||
        key === "analytics_events" ||
        key === "attribution_data" ||
        key === "lingoshade_campaign_attribution"
      )
        localStorage.removeItem(key);
    }
    sessionStorage.removeItem("current_session");
    const names = document.cookie
      .split(";")
      .map((value) => value.trim().split("=")[0])
      .filter(
        (name) => /^ph_.*_posthog$/.test(name) || name === "attribution_data",
      );
    const parts = location.hostname.split(".");
    const domains = [
      "",
      ...parts
        .map((_, index) => parts.slice(index).join("."))
        .filter((domain) => domain.includes(".")),
    ];
    for (const name of names) {
      for (const domain of domains) {
        document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax${domain ? `; Domain=${domain}` : ""}`;
      }
    }
  } catch {
    // Storage may be unavailable; no analytics is initialized in either case.
  }
}
